export type FetchCustomerCustomFieldResponse = {
  id: number;
  fieldName: string;
  dataType: FetchCustomFieldResponseDataType;
  fieldType: FetchCustomFieldResponseFieldType;
  options: string[];
  isVisible: boolean;
  createdAt: string;
  updatedAt: string;
  storeId: string;
  aliasName?: string;
}

export enum FetchCustomFieldResponseDataType {
  STRING = 'string',
  STRING_ARRAY = 'string_array',
  DATE = 'date',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
}

export enum FetchCustomFieldResponseFieldType {
  SINGLE_LINE = 'single_line',
  MULTI_LINE = 'multi_line',
  MULTISELECT_DROPDOWN = 'multiselect_dropdown',
  DROPDOWN = 'dropdown',
  DATE = 'date',
  NUMBER = 'number',
  CHECKBOX = 'checkbox',
  DATE_TIME = 'date_time',
}